import "./sberpay-btn.css";

const SberPayBtn = ({ disabled, onClick }) => {

  return<div className={"sberpay-btn-main" + (disabled ? " sberpay-btn-disabled" : "")}>
    <div className={"sberpay-btn"+ (disabled ? " sberpay-btn-notallowed" : "")} onClick={disabled ? null : onClick} >
    <img src={disabled ? "/images/sp-gray.svg" : "/images/sp-active.svg"} alt="sp" />
    <div>Pay</div>
  </div></div>
}

export default SberPayBtn;